import { VALID_STATUSES, VALID_SERVICE_TYPES, VALIDATION_RULES } from '../config/jobConstants';

// Validate job data
export const validateJobData = (jobData, isUpdate = false) => {
  const errors = [];

  // Title validation
  if (!isUpdate || jobData.title !== undefined) {
    if (!jobData.title || jobData.title.trim().length < VALIDATION_RULES.TITLE.min) {
      errors.push(`Job title must be at least ${VALIDATION_RULES.TITLE.min} characters long`);
    }
    if (jobData.title && jobData.title.length > VALIDATION_RULES.TITLE.max) {
      errors.push(`Job title must not exceed ${VALIDATION_RULES.TITLE.max} characters`);
    }
  }

  // Customer ID validation (for new jobs)
  if (!isUpdate) {
    if (!jobData.customer_id) {
      errors.push('Customer is required');
    }
  }

  // Service type validation
  if (!isUpdate || jobData.service_type !== undefined) {
    if (!jobData.service_type || !VALID_SERVICE_TYPES.includes(jobData.service_type)) {
      errors.push('Service type must be inspection, treatment, maintenance, or emergency');
    }
  }

  // Scheduled date validation
  if (!isUpdate || jobData.scheduled_date !== undefined) {
    if (!jobData.scheduled_date) {
      errors.push('Scheduled date is required');
    } else {
      const scheduledDate = new Date(jobData.scheduled_date);
      if (isNaN(scheduledDate.getTime())) {
        errors.push('Please provide a valid scheduled date');
      }
    }
  }

  // Status validation
  if (jobData.status) {
    if (!VALID_STATUSES.includes(jobData.status)) {
      errors.push('Status must be scheduled, in_progress, completed, or cancelled');
    }
  }

  // Duration validation
  if (jobData.estimated_duration !== undefined && jobData.estimated_duration !== null) {
    const duration = parseInt(jobData.estimated_duration);
    if (isNaN(duration) || duration < VALIDATION_RULES.DURATION.min || duration > VALIDATION_RULES.DURATION.max) {
      errors.push(`Estimated duration must be between ${VALIDATION_RULES.DURATION.min} and ${VALIDATION_RULES.DURATION.max} minutes`);
    }
  }

  if (jobData.actual_duration !== undefined && jobData.actual_duration !== null) {
    const duration = parseInt(jobData.actual_duration);
    if (isNaN(duration) || duration < VALIDATION_RULES.ACTUAL_DURATION.min || duration > VALIDATION_RULES.ACTUAL_DURATION.max) {
      errors.push(`Actual duration must be between ${VALIDATION_RULES.ACTUAL_DURATION.min} and ${VALIDATION_RULES.ACTUAL_DURATION.max} minutes`);
    }
  }

  // Price validation
  if (jobData.price !== undefined && jobData.price !== null) {
    const price = parseFloat(jobData.price);
    if (isNaN(price) || price < VALIDATION_RULES.PRICE.min) {
      errors.push('Price must be a positive number');
    }
  }

  return {
    isValid: errors.length === 0,
    errors
  };
};